import { ImageSettings } from './imageSetting'

export class CustomSetting {
	public name?: string
	public images?: ImageSettings

	constructor(data: { name?: string; images?: ImageSettings }) {
		this.name = data.name
		this.images = data.images
	}

	static create(data: Partial<CustomSetting>): CustomSetting {
		const defaultData: CustomSetting = {
			name: '',
			images: ImageSettings.create({}),
		}

		return new CustomSetting({
			...defaultData,
			...data,
		})
	}
}
